import ApiService from "@/_services/api/api.service";
import appConfig from "@/app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProductionCalendarLinkedSOService = {

    async reOrderLinkedSalesOrder(payload) {

        const url = "api/WorkOrder/ReorderProcessWorkOrderSalesOrderLineSequence";

        return await ApiService.post(url, payload);
    },
}

export { ProductionCalendarLinkedSOService };